module.exports = __webpack_public_path__ + "static/inline-edit-textfield-do-32b4febf432325279671b3f3ab28b074.png";